export default __webpack_public_path__ + "static/media/new_task.a3941ab6.svg";